// tslint:disable:max-line-length
import React from 'react'
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

const QuizIntroButtonIcon: React.SFC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g fill="#27354F" fillRule="evenodd" clipRule="evenodd" opacity=".25">
        <path d="M6.35 8.7c-.64.45-1.22.98-1.71 1.58C4.58 10.21.72 2.12.13.88L.05.7A.5.5 0 0 1 .5 0h1.73l4.12 8.7zM5.95.29L9.27 7.3c-.73.2-1.43.48-2.08.84L3.33 0H5.5c.2 0 .37.11.45.29zm13.4 10a9.07 9.07 0 0 0-1.7-1.6L21.77 0h1.73a.5.5 0 0 1 .45.71l-.08.16c-.6 1.25-4.46 9.34-4.51 9.41zm-1.37-10L14.66 7.3c.73.2 1.43.48 2.08.84L20.6 0h-2.17a.5.5 0 0 0-.45.29z"/>
        <path d="M20 16a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-4.87 3.4l-.82-3.02 2.02-1.7a.5.5 0 0 0 .14-.53.45.45 0 0 0-.42-.32h-2.42l-1.22-2.59c-.16-.32-.66-.32-.8 0l-1.24 2.6H7.95a.45.45 0 0 0-.42.3.5.5 0 0 0 .14.54l2.02 1.7-.82 3.02a.5.5 0 0 0 .16.5c.15.12.35.13.51.03L12 18.3l2.46 1.63c.16.1.36.1.51-.02a.5.5 0 0 0 .16-.51z"/>
      </g>
    </SvgIcon>
  )
}

export default QuizIntroButtonIcon
